import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export default function ActionItemsSkeleton({ isDarkMode }) {
    const cardCls = `rounded-2xl border shadow-sm ${isDarkMode ? "bg-slate-800 border-slate-700" : "bg-white border-slate-200"}`;
    const baseColor = isDarkMode ? "#334155" : "#e2e8f0";
    const highlightColor = isDarkMode ? "#475569" : "#f1f5f9";

    return (
        <SkeletonTheme baseColor={baseColor} highlightColor={highlightColor}>
            <div className={`min-h-screen ${isDarkMode ? "bg-surface" : "bg-surface"}`}>
                <section className="max-w-6xl mx-auto px-4 py-8">
                    {/* Header: title/subtitle + Add Task button */}
                    <header className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-6">
                        <div>
                            <Skeleton width={200} height={30} className="mb-2" />
                            <Skeleton width={300} height={16} />
                        </div>
                        <Skeleton width={110} height={40} borderRadius={8} />
                    </header>

                    {/* Search and filter bar */}
                    <div className={`${cardCls} p-4 mb-6`}>
                        <div className="flex flex-col md:flex-row gap-4">
                            <div className="flex-1">
                                <Skeleton height={40} borderRadius={8} />
                            </div>
                            <div className="flex gap-2">
                                <Skeleton width={90} height={40} borderRadius={8} />
                                <Skeleton width={100} height={40} borderRadius={8} />
                            </div>
                        </div>
                    </div>

                    {/* Focus-area sections with task rows */}
                    {Array.from({ length: 2 }).map((_, s) => (
                        <div key={s} className={`${cardCls} mb-6 overflow-hidden`}>
                            <div className={`px-4 py-3 border-b ${isDarkMode ? "border-slate-700" : "border-slate-200"}`}>
                                <Skeleton width={180} height={20} />
                            </div>
                            <div className="p-4 space-y-3">
                                {Array.from({ length: 4 }).map((_, r) => (
                                    <Skeleton key={r} height={52} borderRadius={8} />
                                ))}
                            </div>
                        </div>
                    ))}
                </section>
            </div>
        </SkeletonTheme>
    );
}
